/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest, put, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { AxiosResponse } from 'axios';
import { processRequestError } from '../error/actions';
import {
  GET_ORDERS_REQUEST,
  GET_ORDER_REQUEST,
  CREATE_ORDER_REQUEST,
  DELETE_ORDER_REQUEST,
  COMMIT_ORDER_REQUEST,
  GET_ORDER_ITEM_REQUEST,
  UPDATE_ORDER_ITEM_REQUEST,
  DELETE_ORDER_ITEM_REQUEST,
} from './types';
import {
  getOrdersAction,
  getOrderByIdAction,
  createOrderAction,
  deleteOrderAction,
  commitOrderAction,
  getOrderItemAction,
  updateOrderItemAction,
  deleteOrderItemAction,
} from './actions';
import { OrdersApi } from '../../services/Orders';

// Сага для получения списка заказов
function* handleGetOrdersSaga(): SagaIterator {
  try {
    const response: AxiosResponse = yield call(OrdersApi.getOrders);
    yield put(getOrdersAction.success(response.data));
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: getOrdersAction.failure }));
  }
}

// Сага для получения одного заказа по ID
function* handleGetOrderSaga(action: ReturnType<typeof getOrderByIdAction.request>): SagaIterator {
  try {
    const response: AxiosResponse = yield call(OrdersApi.getOrder, action.payload);
    yield put(getOrderByIdAction.success(response.data));
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: getOrderByIdAction.failure }));
  }
}

// Сага для создания заказа
function* handleCreateOrderSaga(
  action: ReturnType<typeof createOrderAction.request>,
): SagaIterator {
  try {
    const response: AxiosResponse = yield call(OrdersApi.createOrder, action.payload);
    yield put(createOrderAction.success(response.data));
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: createOrderAction.failure }));
  }
}

// Сага для удаления заказа
function* handleDeleteOrderSaga(
  action: ReturnType<typeof deleteOrderAction.request>,
): SagaIterator {
  try {
    yield call(OrdersApi.deleteOrder, action.payload);
    yield put(deleteOrderAction.success(action.payload));
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: deleteOrderAction.failure }));
  }
}

// Сага для коммита заказа
function* handleCommitOrderSaga(
  action: ReturnType<typeof commitOrderAction.request>,
): SagaIterator {
  try {
    const response: AxiosResponse = yield call(OrdersApi.commitOrder, action.payload);
    yield put(commitOrderAction.success(response.data));
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: commitOrderAction.failure }));
  }
}

// Сага для добавления товаров в заказ
// function* handleAddItemsSaga(action: ReturnType<typeof addItemsAction.request>): SagaIterator {
//   try {
//     const { id, items } = action.payload;
//     const response: AxiosResponse = yield call(OrdersApi.addItems, id, items);
//     yield put(addItemsAction.success(response.data));
//   } catch (error: AxiosResponse['data']) {
//     yield put(processRequestError({ error, failAction: addItemsAction.failure }));
//   }
// }

// Сага для получения товара по ID
function* handleGetOrderItemSaga(
  action: ReturnType<typeof getOrderItemAction.request>,
): SagaIterator {
  try {
    const response: AxiosResponse = yield call(OrdersApi.getOrderItem, action.payload);
    yield put(getOrderItemAction.success(response.data));
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: getOrderItemAction.failure }));
  }
}

// Сага для обновления товара в заказе
function* handleUpdateOrderItemSaga(
  action: ReturnType<typeof updateOrderItemAction.request>,
): SagaIterator {
  try {
    const { id, item } = action.payload;
    const response: AxiosResponse = yield call(OrdersApi.updateOrderItem, id, item);
    yield put(updateOrderItemAction.success(response.data));
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: updateOrderItemAction.failure }));
  }
}

// Сага для удаления товара из заказа
function* handleDeleteOrderItemSaga(
  action: ReturnType<typeof deleteOrderItemAction.request>,
): SagaIterator {
  try {
    yield call(OrdersApi.deleteOrderItem, action.payload);
    yield put(deleteOrderItemAction.success(action.payload));
  } catch (error: AxiosResponse['data']) {
    yield put(processRequestError({ error, failAction: deleteOrderItemAction.failure }));
  }
}

// Главная сага для отслеживания всех действий
function* ordersSaga(): SagaIterator {
  yield takeLatest(GET_ORDERS_REQUEST, handleGetOrdersSaga);
  yield takeLatest(GET_ORDER_REQUEST, handleGetOrderSaga);
  yield takeLatest(CREATE_ORDER_REQUEST, handleCreateOrderSaga);
  yield takeLatest(DELETE_ORDER_REQUEST, handleDeleteOrderSaga);
  yield takeLatest(COMMIT_ORDER_REQUEST, handleCommitOrderSaga);
  // yield takeLatest(ADD_ITEMS_REQUEST, handleAddItemsSaga);
  yield takeLatest(GET_ORDER_ITEM_REQUEST, handleGetOrderItemSaga);
  yield takeLatest(UPDATE_ORDER_ITEM_REQUEST, handleUpdateOrderItemSaga);
  yield takeLatest(DELETE_ORDER_ITEM_REQUEST, handleDeleteOrderItemSaga);
}

export default ordersSaga;
